//#region src/coupon_code_transform.ts
var CouponCodeTransform = /* @__PURE__ */ function(CouponCodeTransform) {
	CouponCodeTransform["LowerCase"] = "lower-case";
	CouponCodeTransform["None"] = "none";
	CouponCodeTransform["UpperCase"] = "upper-case";
	return CouponCodeTransform;
}(CouponCodeTransform || {});
//#endregion
export { CouponCodeTransform };

//# sourceMappingURL=coupon_code_transform.js.map